import { LandingLayoutHeader } from '../Layout/LayoutHeader';
import { LayoutBackground } from '../Layout/components';

import { ConsentSuccessContent } from './ConsentSuccessContent';

export const ExplicitConsentSuccess = () => {
  return (
    <LayoutBackground>
      <LandingLayoutHeader />
      <ConsentSuccessContent isOnlinePayment />
    </LayoutBackground>
  );
};
